export default "/images/alucha.gif?7a46b509580988ee888c8b072e8c64d1";